import "@mantine/core/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { DehubThemeProvider } from "@dehub/theme";
import "./i18n-setup";
import { App } from "./app";
import { prefetchBootMe } from "./boot-me";
import { ErrorBoundary } from "./error-boundary";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./styles/base.css";

const themeOverride = {
  components: {
    Breadcrumbs: {
      styles: {
        breadcrumb: {
          color: "var(--mantine-color-gray-7)",
          fontSize: "var(--mantine-font-size-sm)",
        },
      },
    },
  },
};

prefetchBootMe();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={(window as any).__BASE_PATH__ || ""}>
          <DehubThemeProvider themeOverride={themeOverride}>
            <ErrorBoundary>
              <ModalsProvider>
                <Notifications position="top-right" />
                <App />
              </ModalsProvider>
            </ErrorBoundary>
          </DehubThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
